import { render, staticRenderFns } from "./HostingSpam.vue?vue&type=template&id=5ffd64dd&"
import script from "./HostingSpam.vue?vue&type=script&lang=js&"
export * from "./HostingSpam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports